import React, {memo} from "react";
import Label from "components/general/Label"
import useViewport from "components/general/useViewPort";
import { arraysEqual } from "helpers/utils";
import SportCode from "components/common/SportCode";

export const TableExpanded = memo((props) => {
    const { breakPoint } = useViewport();
    const {row} = props;
    const isMobile = breakPoint === "sm" || breakPoint === "xs" 
    const techPoints = row?.extendedResults?.find(er => er?.er_code === 'D_TECH')?.er_value;
    const artisticPoints = row?.extendedResults?.find(er => er?.er_code === 'D_ARTISTIC')?.er_value;
    //console.log(row)

    const xl = (
        <table className="w-100 table-borderless">
            <thead>
                <tr>
                    <td className="w-40" ></td>
                    <td className="w-40" ></td>
                    <td className="text-end fw-bold w-15" ><Label data='HeaderPercentScore' /></td>
                    <td className="w-5" ></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td></td>
                    <td className="text-start fw-bold"><Label data='HeaderTechnical' /></td>
                    <td className="text-end">{techPoints}</td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td className="text-start fw-bold"><Label data='HeaderArtistic' /></td>
                    <td className="text-end">{artisticPoints}</td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    );

    return <>{isMobile ? xl : xl}</>

}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    //renderizamos cuando un dato de los visibles cambia
    //return false;
    return arraysEqual(prevProps?.res?.extendedResults, nextProps?.res?.extendedResults);
});